import Breadcrumbs from 'components/Breadcrumbs';
import { Button } from 'components/buttons/Button/Button';
import 'components/Banner/styles.scss';

const Banner = ({ title, image, buttonText }) => {
    return (
        <div className="primary-section-wrapper">
            <div className="primary-section">
                <div className="left-side">
                    <Breadcrumbs />
                    <h2>{title}</h2>
                </div>
                <div className="button-wrapper">
                    <Button type="learn-more">{buttonText}</Button>
                    <div className="smooth-corner1"></div>
                    <div className="smooth-corner2"></div>
                </div>
            </div>
            <img src={image} alt={title} />
        </div>
    );
};
export default Banner;
